import { Map as map } from 'immutable';
const C = require("../constants");

function ProductStockReducer(state = map(), action) {
    switch (action.type) {
        case C.PRODUCTS_STOCK:
            return action.products_stock;
        case C.PRODUCTS_STOCK_UPDATE:
            return state.map((product_stock)=> {
                if(product_stock.id === action.product_stock.id ) {
                    return action.product_stock
                } else {
                    return product_stock;
                }
            });
        default:
            return state;
    }
}

export default ProductStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductStockReducer.js